var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 47.2L25.8 38.6C25.0667 37.8667 24.1333 37.5 23 37.5C21.8667 37.5 20.9333 37.8667 20.2 38.6C19.4667 39.3333 19.1 40.2667 19.1 41.4C19.1 42.5333 19.4667 43.4667 20.2 44.2L31.6 55.6C32.4 56.4 33.3333 56.8 34.4 56.8C35.4667 56.8 36.4 56.4 37.2 55.6L59.8 33C60.5333 32.2667 60.9 31.3333 60.9 30.2C60.9 29.0667 60.5333 28.1333 59.8 27.4C59.0667 26.6667 58.1333 26.3 57 26.3C55.8667 26.3 54.9333 26.6667 54.2 27.4L34.4 47.2ZM40 80C34.4667 80 29.2667 78.9493 24.4 76.848C19.5333 74.7467 15.3 71.8973 11.7 68.3C8.1 64.7 5.25067 60.4667 3.152 55.6C1.05333 50.7333 0.00266667 45.5333 0 40C0 34.4667 1.05067 29.2667 3.152 24.4C5.25333 19.5333 8.10267 15.3 11.7 11.7C15.3 8.1 19.5333 5.25067 24.4 3.152C29.2667 1.05333 34.4667 0.00266667 40 0C45.5333 0 50.7333 1.05067 55.6 3.152C60.4667 5.25333 64.7 8.10267 68.3 11.7C71.9 15.3 74.7507 19.5333 76.852 24.4C78.9533 29.2667 80.0027 34.4667 80 40C80 45.5333 78.9493 50.7333 76.848 55.6C74.7467 60.4667 71.8973 64.7 68.3 68.3C64.7 71.9 60.4667 74.7507 55.6 76.852C50.7333 78.9533 45.5333 80.0027 40 80Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagamento);
export default __webpack_public_path__ + "static/media/Pagamento.3787f6059d8c4caf68475da76bd5ff95.svg";
export { ForwardRef as ReactComponent };